import { v3 as v3Entities } from './v3.entities';

export namespace RolloutProgressReportEntities {
  export import v3 = v3Entities;
}
